"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/gifts-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2),\n          0px 0px 6px rgba(52, 133, 254, 0.8) !important;\n        border-radius: 10px\n          10px 0 0 !important;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      border-radius: 10px !important;\n      height: 100%;\n      background-color: #F1F7FD !important;\n      border: 1px solid #C8CDD8;\n      color: ", ";\n\n      box-shadow: inset 0px 2px 6px rgba(0, 0, 0, 0.1),\n        inset 0px 1px 2px rgba(0, 0, 0, 0.1) !important;\n      -moz-appearance: textfield;\n      outline: none;\n\n      &:focus,\n      &:focus-within {\n        border: 2px solid ", ";\n        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2),\n          0px 0px 6px rgba(52, 133, 254, 0.8);\n      }\n\n      ", "\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

var react_select_1 = require("react-select");

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

var Control = styled_components_1["default"](react_select_1.components.Control)(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      menuIsOpen = _ref.menuIsOpen;
  return styled_components_1.css(_templateObject2(), theme.palette.text["default"], bitcoincom_pkg_theme_1.colors.solid.primaryBlue, menuIsOpen && styled_components_1.css(_templateObject3()));
});
exports["default"] = Control;